import PropTypes from 'prop-types';
import React from 'react';
import { Switch } from 'react-aria-components';

import Typography from '../../Typography/Typography';
import styles from './Switch.module.scss';

/**
 * The Switch component is a form control that allows the user to toggle between two states.
 * It is a visual representation of a checkbox that allows the user to select between two options.
 *
 * Usage:
 * - Default Usage: Employs default Design System values for the switch component.
 */
const SwitchInput = ({ label, defaultSelected, isDisabled, ...props }) => {
    return (
        <Switch
            defaultSelected={defaultSelected}
            isDisabled={isDisabled}
            className={styles['switch']}
            {...props}
        >
            <div className={styles['indicator']} />
            {label && (
                <Typography
                    variant={Typography.VARIANT.T2}
                    color={Typography.COLOR.INHERIT}
                    content={label}
                />
            )}
        </Switch>
    );
};

SwitchInput.propTypes = {
    /**
     * Visual label of the input element.
     */
    label: PropTypes.node,
    /**
     * Whether the element should be selected (uncontrolled).
     */
    defaultSelected: PropTypes.bool,
    /**
     * Whether the input is disabled.
     */
    isDisabled: PropTypes.bool,
};
export default SwitchInput;
